<template>
  <div class="cell-renderer-offline-online rater-buttons-wrapper">
    <div class="rater-buttons d-flex">
      <vs-button
          class="mr-2"
          size="small"
          color="secondary"
          :disabled="!offlineRateGuid"
          @click="offlineClicked"
      >
        Offline
      </vs-button>
      <vs-button
          size="small"
          color="black"
          type="border"
          :disabled="!onlineRaterGuid"
          @click="onlineClicked"
      >
        Online
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
name: 'CellRendererOfflineOnline',
computed: {
  offlineRaterTypeId() {
    return this.params.offlineRaterCol.ID;
  },
  offlineRaterType() {
    return this.params.offlineRaterCol.Document_Type;
  },
  offlineRateGuid() {
    if (!this.params || !this.params.data) {
      return '';
    }

    return this.params.data[`DocumentType_${this.offlineRaterTypeId}`];
  },
  onlineRaterTypeId() {
    return this.params.onlineRaterCol.ID;
  },
  onlineRaterType() {
    return this.params.onlineRaterCol.Document_Type;
  },
  onlineRaterGuid() {
    if (!this.params || !this.params.data) {
      return '';
    }

    return this.params.data[`DocumentType_${this.onlineRaterTypeId}`];
  },
},
methods: {
  offlineClicked() {
    this.download(
        this.offlineRateGuid,
        this.offlineRaterType,
        this.offlineRaterTypeId
    )
  },
  onlineClicked() {
    this.download(
        this.onlineRaterGuid,
        this.onlineRaterType,
        this.onlineRaterTypeId
    )
  },
  download(documentGuid, documentType, documentTypeId) {
    const params = {
      documentGuid: [documentGuid],
      documentType: 'salesDocument',
      documentTypeId
    };

    this.$parent.$emit('download', params);
  }
}
}
</script>

<style lang="scss">
@import '@/assets/scss/custom/components/variables';
.cell-renderer-offline-online {
  .rater-buttons-wrapper {
    height: 100%;
    display: flex;
    align-items: center;

    .rater-buttons {
      button {
        padding: 2.5px 7px !important;

        span {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
